
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ReportLoading } from "@/components/reports/ReportLoading";
import { useAuth } from "../context/auth/AuthContext";
import { Navigate } from "react-router-dom";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { LogsTable } from "@/components/admin/LogsTable";
import { LogsPagination } from "@/components/admin/LogsPagination";
import { useAdminLogs } from "@/hooks/useAdminLogs";

const AdminLogs: React.FC = () => {
  const { isAdmin } = useAuth();
  const { logs, isLoading, currentPage, totalPages, handlePageChange } = useAdminLogs();
  
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8">
            <Card className="shadow-lg">
              <CardHeader>
                <CardTitle className="text-2xl">Admin Logs</CardTitle>
              </CardHeader>
              <CardContent>
                {isLoading ? (
                  <ReportLoading />
                ) : (
                  <>
                    <LogsTable logs={logs} />
                    <LogsPagination 
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  </>
                )}
              </CardContent>
            </Card>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AdminLogs;
